module.exports = __webpack_public_path__ + "img/The_Spotted_Cow@1x.f73d8d13.png";